import { render, staticRenderFns } from "./UnavailableLogs.vue?vue&type=template&id=b89b46c8&"
import script from "./UnavailableLogs.vue?vue&type=script&lang=js&"
export * from "./UnavailableLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports